<template lang="pug">
.assistant-result-wrapper(v-if='menu != null')
  .assistant-result-header(v-if='assistantResult')
    .assistant-result-header-left
      icon(:name='`ic-${menu.id}`')
      p Qiscus AI Assistant {{ generatedLabel }}
    .assistant-result-header-right(@click='closeMenu')
      icon(:name='`ic-assistant-close`')
  .assistant-result-loader(v-if='!assistantResult || regenerate')
    img(src='https://dnlbo7fgjcc7f.cloudfront.net/fulda-5g5sizvzw3ch9mj/image/upload/BfN50FQ9PI/795f86ade3ee9d068516d41c7a8046ae.gif' alt='Assistant Loader')
    span Qiscus AI Assistant {{ generatedLoaderLabel }}
  .assistant-result-content(v-if='assistantResult && !regenerate')
    | {{ assistantResult }}
  .assistant-result-actions(v-if='assistantResult && !regenerate')
    .assistant-result-actions-left(@click='dropdown.opened = !dropdown.opened')
      .custom-dropdown(:class='{active:dropdown.opened}')
        .selected-option {{ dropdown.selected }}
        .options
          .option(@click="setDropdown('Lengthen Text')") Lengthen Text
          .option(@click="setDropdown('Shorten Text')") Shorten Text
      svg(xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewbox='0 0 18 18' fill='none')
        path(d='M4.5 6.75L9 11.25L13.5 6.75' stroke='#27B199' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round')
    .assistant-result-actions-right
      .regenerate(@click='regenerateWithOptions')
        svg(xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewbox='0 0 18 18' fill='none')
          g(clip-path='url(#clip0_4467_533)')
            mask#path-1-inside-1_4467_533(fill='white')
              path(d='M9.00015 1.49996C9.99503 1.50323 10.9794 1.70377 11.8963 2.08998C12.8131 2.47619 13.6443 3.0404 14.3417 3.74996H12.0002C11.8012 3.74996 11.6105 3.82898 11.4698 3.96963C11.3292 4.11029 11.2502 4.30105 11.2502 4.49996C11.2502 4.69888 11.3292 4.88964 11.4698 5.03029C11.6105 5.17095 11.8012 5.24996 12.0002 5.24996H15.1074C15.4767 5.24976 15.8309 5.10297 16.092 4.84182C16.3532 4.58067 16.5 4.22653 16.5002 3.85721V0.749963C16.5002 0.551051 16.4211 0.360285 16.2805 0.219633C16.1398 0.0789805 15.9491 -3.71674e-05 15.7502 -3.71674e-05C15.5512 -3.71674e-05 15.3605 0.0789805 15.2198 0.219633C15.0792 0.360285 15.0002 0.551051 15.0002 0.749963V2.30846C13.7605 1.19205 12.2346 0.44277 10.5932 0.144525C8.95186 -0.153721 7.25987 0.0108468 5.70674 0.619799C4.15361 1.22875 2.80066 2.25804 1.79941 3.59241C0.798157 4.92677 0.188133 6.51352 0.0376519 8.17496C0.0279644 8.27941 0.0401387 8.38472 0.0733991 8.4842C0.106659 8.58368 0.160277 8.67514 0.230834 8.75275C0.301392 8.83037 0.387343 8.89243 0.483211 8.93499C0.579078 8.97756 0.682761 8.99968 0.787652 8.99996C0.971093 9.0023 1.1488 8.93609 1.286 8.8143C1.42319 8.6925 1.50999 8.52389 1.5294 8.34146C1.69636 6.47452 2.55538 4.73749 3.93771 3.47159C5.32004 2.20569 7.12576 1.50243 9.00015 1.49996Z')
            path(d='M9.00015 1.49996C9.99503 1.50323 10.9794 1.70377 11.8963 2.08998C12.8131 2.47619 13.6443 3.0404 14.3417 3.74996H12.0002C11.8012 3.74996 11.6105 3.82898 11.4698 3.96963C11.3292 4.11029 11.2502 4.30105 11.2502 4.49996C11.2502 4.69888 11.3292 4.88964 11.4698 5.03029C11.6105 5.17095 11.8012 5.24996 12.0002 5.24996H15.1074C15.4767 5.24976 15.8309 5.10297 16.092 4.84182C16.3532 4.58067 16.5 4.22653 16.5002 3.85721V0.749963C16.5002 0.551051 16.4211 0.360285 16.2805 0.219633C16.1398 0.0789805 15.9491 -3.71674e-05 15.7502 -3.71674e-05C15.5512 -3.71674e-05 15.3605 0.0789805 15.2198 0.219633C15.0792 0.360285 15.0002 0.551051 15.0002 0.749963V2.30846C13.7605 1.19205 12.2346 0.44277 10.5932 0.144525C8.95186 -0.153721 7.25987 0.0108468 5.70674 0.619799C4.15361 1.22875 2.80066 2.25804 1.79941 3.59241C0.798157 4.92677 0.188133 6.51352 0.0376519 8.17496C0.0279644 8.27941 0.0401387 8.38472 0.0733991 8.4842C0.106659 8.58368 0.160277 8.67514 0.230834 8.75275C0.301392 8.83037 0.387343 8.89243 0.483211 8.93499C0.579078 8.97756 0.682761 8.99968 0.787652 8.99996C0.971093 9.0023 1.1488 8.93609 1.286 8.8143C1.42319 8.6925 1.50999 8.52389 1.5294 8.34146C1.69636 6.47452 2.55538 4.73749 3.93771 3.47159C5.32004 2.20569 7.12576 1.50243 9.00015 1.49996Z' fill='#27B199')
            path(d='M9.00015 1.49996L9.07014 -19.8333L9.02109 -19.8334L8.97204 -19.8334L9.00015 1.49996ZM14.3417 3.74996V25.0833H65.2201L29.5568 -11.2037L14.3417 3.74996ZM15.1074 5.24996V26.5833L15.1189 26.5833L15.1074 5.24996ZM16.5002 3.85721L37.8335 3.86869V3.85721H16.5002ZM15.0002 2.30846L0.723605 18.1606L36.3335 50.2311V2.30846H15.0002ZM0.0376519 8.17496L21.2798 10.1452L21.2819 10.1223L21.284 10.0993L0.0376519 8.17496ZM1.5294 8.34146L22.7429 10.5991L22.7619 10.4205L22.7779 10.2417L1.5294 8.34146ZM8.93017 22.8332C7.10419 22.8272 5.29753 22.4591 3.61474 21.7503L20.1778 -17.5703C16.6612 -19.0516 12.8859 -19.8207 9.07014 -19.8333L8.93017 22.8332ZM3.61474 21.7503C1.93195 21.0414 0.406453 20.0059 -0.873471 18.7036L29.5568 -11.2037C26.8821 -13.9251 23.6943 -16.0891 20.1778 -17.5703L3.61474 21.7503ZM14.3417 -17.5834H12.0002V25.0833H14.3417V-17.5834ZM12.0002 -17.5834C6.14327 -17.5834 0.526295 -15.2567 -3.61512 -11.1153L26.5548 19.0546C22.6947 22.9147 17.4592 25.0833 12.0002 25.0833V-17.5834ZM-3.61512 -11.1153C-7.75654 -6.97389 -10.0832 -1.35692 -10.0832 4.49996H32.5835C32.5835 9.95902 30.4149 15.1945 26.5548 19.0546L-3.61512 -11.1153ZM-10.0832 4.49996C-10.0832 10.3568 -7.75654 15.9738 -3.61512 20.1152L26.5548 -10.0547C30.4149 -6.19454 32.5835 -0.95909 32.5835 4.49996H-10.0832ZM-3.61512 20.1152C0.526295 24.2567 6.14327 26.5833 12.0002 26.5833V-16.0834C17.4592 -16.0834 22.6947 -13.9148 26.5548 -10.0547L-3.61512 20.1152ZM12.0002 26.5833H15.1074V-16.0834H12.0002V26.5833ZM15.1189 26.5833C21.1422 26.5801 26.9178 24.1859 31.177 19.9268L1.00706 -10.2431C4.74388 -13.98 9.81128 -16.0805 15.0959 -16.0834L15.1189 26.5833ZM31.177 19.9268C35.4361 15.6676 37.8302 9.89198 37.8335 3.86869L-4.83318 3.84573C-4.83033 -1.43891 -2.72976 -6.50631 1.00706 -10.2431L31.177 19.9268ZM37.8335 3.85721V0.749963H-4.83318V3.85721H37.8335ZM37.8335 0.749963C37.8335 -5.10686 35.5069 -10.7239 31.3654 -14.8653L1.19554 15.3046C-2.66461 11.4444 -4.83318 6.20896 -4.83318 0.749963H37.8335ZM31.3654 -14.8653C27.224 -19.0068 21.607 -21.3334 15.7502 -21.3334V21.3333C10.2911 21.3333 5.05567 19.1647 1.19554 15.3046L31.3654 -14.8653ZM15.7502 -21.3334C9.8933 -21.3334 4.27632 -19.0068 0.134876 -14.8653L30.3048 15.3046C26.4446 19.1647 21.2092 21.3333 15.7502 21.3333V-21.3334ZM0.134876 -14.8653C-4.00658 -10.7239 -6.33318 -5.10686 -6.33318 0.749963H36.3335C36.3335 6.20896 34.1649 11.4444 30.3048 15.3046L0.134876 -14.8653ZM-6.33318 0.749963V2.30846H36.3335V0.749963H-6.33318ZM29.2767 -13.5437C25.0941 -17.3106 19.9453 -19.8388 14.4072 -20.8451L6.77929 21.1342C4.52384 20.7243 2.42701 19.6947 0.723605 18.1606L29.2767 -13.5437ZM14.4072 -20.8451C8.86898 -21.8514 3.15999 -21.2962 -2.08047 -19.2415L13.494 20.4811C11.3598 21.3179 9.03474 21.544 6.77929 21.1342L14.4072 -20.8451ZM-2.08047 -19.2415C-7.32094 -17.1868 -11.886 -13.7138 -15.2643 -9.21152L18.8631 16.3963C17.4873 18.2299 15.6282 19.6443 13.494 20.4811L-2.08047 -19.2415ZM-15.2643 -9.21152C-18.6427 -4.7092 -20.701 0.644698 -21.2087 6.25062L21.284 10.0993C21.0772 12.3823 20.239 14.5627 18.8631 16.3963L-15.2643 -9.21152ZM-21.2045 6.20468C-21.4878 9.25929 -21.1318 12.3394 -20.159 15.2489L20.3058 1.71954C21.2121 4.43001 21.5438 7.29953 21.2798 10.1452L-21.2045 6.20468ZM-20.159 15.2489C-19.1863 18.1583 -17.6181 20.8332 -15.5546 23.1031L16.0162 -5.5976C17.9387 -3.48289 19.3996 -0.99092 20.3058 1.71954L-20.159 15.2489ZM-15.5546 23.1031C-13.4909 25.3731 -10.9772 27.1883 -8.17338 28.4331L9.1398 -10.5631C11.7518 -9.4034 14.0937 -7.71234 16.0162 -5.5976L-15.5546 23.1031ZM-8.17338 28.4331C-5.36959 29.6779 -2.33722 30.325 0.730536 30.3332L0.844767 -12.3333C3.70274 -12.3256 6.52774 -11.7228 9.1398 -10.5631L-8.17338 28.4331ZM0.515789 30.3316C6.01275 30.4016 11.338 28.4176 15.4491 24.7679L-12.8771 -7.13933C-9.04037 -10.5454 -4.07056 -12.397 1.05951 -12.3316L0.515789 30.3316ZM15.4491 24.7679C19.5602 21.1182 22.1612 16.0656 22.7429 10.5991L-19.6841 6.08386C-19.1412 0.982183 -16.7138 -3.73322 -12.8771 -7.13933L15.4491 24.7679ZM22.7779 10.2417C22.4707 13.6778 20.8897 16.8747 18.3455 19.2046L-10.4701 -12.2614C-15.7789 -7.39974 -19.0779 -0.728708 -19.7191 6.44121L22.7779 10.2417ZM18.3455 19.2046C15.8014 21.5344 12.478 22.8287 9.02826 22.8333L8.97204 -19.8334C1.77352 -19.8239 -5.1613 -17.123 -10.4701 -12.2614L18.3455 19.2046Z' fill='#27B199' mask='url(#path-1-inside-1_4467_533)')
            mask#path-3-inside-2_4467_533(fill='white')
              path(d='M17.2134 9.00006C17.0299 8.99772 16.8522 9.06393 16.715 9.18573C16.5778 9.30752 16.491 9.47614 16.4716 9.65856C16.3476 11.086 15.8168 12.4479 14.9421 13.5827C14.0674 14.7175 12.8855 15.5776 11.5367 16.061C10.1879 16.5443 8.72877 16.6306 7.33239 16.3097C5.936 15.9887 4.66099 15.2739 3.65862 14.2501H6.00012C6.19903 14.2501 6.3898 14.1711 6.53045 14.0304C6.6711 13.8898 6.75012 13.699 6.75012 13.5001C6.75012 13.3012 6.6711 13.1104 6.53045 12.9697C6.3898 12.8291 6.19903 12.7501 6.00012 12.7501H2.89287C2.70995 12.75 2.52879 12.7859 2.35977 12.8559C2.19075 12.9258 2.03718 13.0284 1.90783 13.1578C1.77848 13.2871 1.6759 13.4407 1.60594 13.6097C1.53598 13.7787 1.50002 13.9599 1.50012 14.1428V17.2501C1.50012 17.449 1.57914 17.6398 1.71979 17.7804C1.86044 17.9211 2.05121 18.0001 2.25012 18.0001C2.44903 18.0001 2.6398 17.9211 2.78045 17.7804C2.9211 17.6398 3.00012 17.449 3.00012 17.2501V15.6916C4.23974 16.808 5.76568 17.5573 7.40705 17.8555C9.04842 18.1538 10.7404 17.9892 12.2935 17.3802C13.8467 16.7713 15.1996 15.742 16.2009 14.4076C17.2021 13.0733 17.8121 11.4865 17.9626 9.82506C17.9723 9.72062 17.9601 9.6153 17.9269 9.51582C17.8936 9.41634 17.84 9.32489 17.7694 9.24727C17.6989 9.16966 17.6129 9.10759 17.5171 9.06503C17.4212 9.02247 17.3175 9.00034 17.2126 9.00006H17.2134Z')
            path(d='M17.2134 9.00006C17.0299 8.99772 16.8522 9.06393 16.715 9.18573C16.5778 9.30752 16.491 9.47614 16.4716 9.65856C16.3476 11.086 15.8168 12.4479 14.9421 13.5827C14.0674 14.7175 12.8855 15.5776 11.5367 16.061C10.1879 16.5443 8.72877 16.6306 7.33239 16.3097C5.936 15.9887 4.66099 15.2739 3.65862 14.2501H6.00012C6.19903 14.2501 6.3898 14.1711 6.53045 14.0304C6.6711 13.8898 6.75012 13.699 6.75012 13.5001C6.75012 13.3012 6.6711 13.1104 6.53045 12.9697C6.3898 12.8291 6.19903 12.7501 6.00012 12.7501H2.89287C2.70995 12.75 2.52879 12.7859 2.35977 12.8559C2.19075 12.9258 2.03718 13.0284 1.90783 13.1578C1.77848 13.2871 1.6759 13.4407 1.60594 13.6097C1.53598 13.7787 1.50002 13.9599 1.50012 14.1428V17.2501C1.50012 17.449 1.57914 17.6398 1.71979 17.7804C1.86044 17.9211 2.05121 18.0001 2.25012 18.0001C2.44903 18.0001 2.6398 17.9211 2.78045 17.7804C2.9211 17.6398 3.00012 17.449 3.00012 17.2501V15.6916C4.23974 16.808 5.76568 17.5573 7.40705 17.8555C9.04842 18.1538 10.7404 17.9892 12.2935 17.3802C13.8467 16.7713 15.1996 15.742 16.2009 14.4076C17.2021 13.0733 17.8121 11.4865 17.9626 9.82506C17.9723 9.72062 17.9601 9.6153 17.9269 9.51582C17.8936 9.41634 17.84 9.32489 17.7694 9.24727C17.6989 9.16966 17.6129 9.10759 17.5171 9.06503C17.4212 9.02247 17.3175 9.00034 17.2126 9.00006H17.2134Z' fill='#27B199')
            path(d='M17.2134 9.00006V30.3334L17.4852 -12.3315L17.2134 9.00006ZM16.4716 9.65856L-4.74192 7.40096L-4.7638 7.60658L-4.7817 7.81259L16.4716 9.65856ZM3.65862 14.2501V-7.08326H-47.0839L-11.585 29.1746L3.65862 14.2501ZM2.89287 12.7501L2.88137 34.0834H2.89287V12.7501ZM1.50012 14.1428H22.8335L22.8335 14.1313L1.50012 14.1428ZM1.50012 17.2501H-19.8332H1.50012ZM3.00012 17.2501H24.3335H3.00012ZM3.00012 15.6916L17.2767 -0.160576L-18.3332 -32.2311V15.6916H3.00012ZM17.9626 9.82506L-3.27953 7.85478L-3.28166 7.87775L-3.28374 7.90073L17.9626 9.82506ZM17.2126 9.00006V-12.3333L17.1555 30.3333L17.2126 9.00006ZM17.4852 -12.3315C11.9883 -12.4016 6.66304 -10.4176 2.55193 -6.76789L30.8781 25.1393C27.0414 28.5455 22.0716 30.397 16.9415 30.3317L17.4852 -12.3315ZM2.55193 -6.76789C-1.5592 -3.11816 -4.16016 1.93448 -4.74192 7.40096L37.6852 11.9162C37.1422 17.0178 34.7149 21.7332 30.8781 25.1393L2.55193 -6.76789ZM-4.7817 7.81259C-4.55253 5.1741 -3.57133 2.65671 -1.95451 0.559081L31.8387 26.6064C35.205 22.2391 37.2478 16.9979 37.7249 11.5045L-4.7817 7.81259ZM-1.95451 0.559081C-0.337697 -1.53854 1.84689 -3.12839 4.3401 -4.02183L18.7334 36.1438C23.9242 34.2837 28.4725 30.9736 31.8387 26.6064L-1.95451 0.559081ZM4.3401 -4.02183C6.8333 -4.91526 9.53046 -5.07478 12.1116 -4.48146L2.55319 37.1008C7.92708 38.336 13.5425 38.0039 18.7334 36.1438L4.3401 -4.02183ZM12.1116 -4.48146C14.6927 -3.88815 17.0495 -2.5669 18.9023 -0.674464L-11.585 29.1746C-7.72749 33.1147 -2.8207 35.8655 2.55319 37.1008L12.1116 -4.48146ZM3.65862 35.5834H6.00012V-7.08326H3.65862V35.5834ZM6.00012 35.5834C11.857 35.5834 17.474 33.2568 21.6154 29.1153L-8.55451 -1.05452C-4.69437 -4.91468 0.541103 -7.08326 6.00012 -7.08326V35.5834ZM21.6154 29.1153C25.7568 24.9739 28.0835 19.3569 28.0835 13.5001H-14.5832C-14.5832 8.04106 -12.4146 2.80561 -8.55451 -1.05452L21.6154 29.1153ZM28.0835 13.5001C28.0835 7.64323 25.7568 2.02625 21.6154 -2.11519L-8.55451 28.0547C-12.4146 24.1945 -14.5832 18.9591 -14.5832 13.5001H28.0835ZM21.6154 -2.11519C17.474 -6.25665 11.857 -8.58327 6.00012 -8.58327V34.0834C0.541103 34.0834 -4.69437 31.9148 -8.55451 28.0547L21.6154 -2.11519ZM6.00012 -8.58327H2.89287V34.0834H6.00012V-8.58327ZM2.90437 -8.58326C-0.0820597 -8.58487 -3.03949 -7.99783 -5.79885 -6.85574L10.5184 32.5675C8.09708 33.5697 5.50195 34.0848 2.88137 34.0834L2.90437 -8.58326ZM-5.79885 -6.85574C-8.55821 -5.71364 -11.0654 -4.03886 -13.1771 -1.92715L16.9928 28.2427C15.1398 30.0957 12.9397 31.5653 10.5184 32.5675L-5.79885 -6.85574ZM-13.1771 -1.92715C-15.2888 0.184566 -16.9636 2.69178 -18.1057 5.45114L21.3176 21.7683C20.3154 24.1896 18.8458 26.3897 16.9928 28.2427L-13.1771 -1.92715ZM-18.1057 5.45114C-19.2478 8.21051 -19.8348 11.1679 -19.8332 14.1543L22.8335 14.1313C22.8349 16.7519 22.3198 19.347 21.3176 21.7683L-18.1057 5.45114ZM-19.8332 14.1428V17.2501H22.8335V14.1428H-19.8332ZM-19.8332 17.2501C-19.8332 23.1069 -17.5066 28.7239 -13.3652 32.8653L16.8048 2.69549C20.6649 6.55563 22.8335 11.7911 22.8335 17.2501H-19.8332ZM-13.3652 32.8653C-9.22372 37.0068 -3.60672 39.3334 2.25012 39.3334V-3.33325C7.70914 -3.33325 12.9446 -1.16467 16.8048 2.69549L-13.3652 32.8653ZM2.25012 39.3334C8.10696 39.3334 13.724 37.0068 17.8654 32.8653L-12.3045 2.69549C-8.44436 -1.16467 -3.20889 -3.33325 2.25012 -3.33325V39.3334ZM17.8654 32.8653C22.0069 28.7239 24.3335 23.1069 24.3335 17.2501H-18.3332C-18.3332 11.7911 -16.1646 6.55563 -12.3045 2.69549L17.8654 32.8653ZM24.3335 17.2501V15.6916H-18.3332V17.2501H24.3335ZM-11.2764 31.5437C-7.09379 35.3107 -1.94508 37.8388 3.5931 38.8452L11.221 -3.13412C13.4764 -2.72429 15.5733 -1.69467 17.2767 -0.160576L-11.2764 31.5437ZM3.5931 38.8452C9.13131 39.8515 14.8403 39.2962 20.0808 37.2415L4.5063 -2.48103C6.6405 -3.31781 8.96552 -3.54395 11.221 -3.13412L3.5931 38.8452ZM20.0808 37.2415C25.3212 35.1868 29.8863 31.7139 33.2646 27.2115L-0.862875 1.60373C0.512969 -0.229859 2.37209 -1.64424 4.5063 -2.48103L20.0808 37.2415ZM33.2646 27.2115C36.6429 22.7092 38.7012 17.3553 39.209 11.7494L-3.28374 7.90073C-3.07696 5.61769 -2.23871 3.4373 -0.862875 1.60373L33.2646 27.2115ZM39.2048 11.7953C39.4881 8.74056 39.132 5.66043 38.1593 2.75118L-2.30554 16.2805C-3.21172 13.5702 -3.5435 10.7007 -3.27953 7.85478L39.2048 11.7953ZM38.1593 2.75118C37.1865 -0.158217 35.6184 -2.83311 33.5548 -5.10306L1.98403 23.5976C0.061563 21.4829 -1.39932 18.9909 -2.30554 16.2805L38.1593 2.75118ZM33.5548 -5.10306C31.4913 -7.37296 28.9775 -9.18819 26.1737 -10.433L8.86046 28.5631C6.24833 27.4034 3.90646 25.7123 1.98403 23.5976L33.5548 -5.10306ZM26.1737 -10.433C23.3699 -11.6778 20.3375 -12.325 17.2697 -12.3332L17.1555 30.3333C14.2975 30.3257 11.4725 29.7228 8.86046 28.5631L26.1737 -10.433ZM17.2126 30.3334H17.2134V-12.3333H17.2126V30.3334Z' fill='#27B199' mask='url(#path-3-inside-2_4467_533)')
          defs
            clippath#clip0_4467_533
              rect(width='18' height='18' fill='white')
      .apply-text(@click="$emit('assistant-apply', true)")
        | Apply Text
</template>
<script>
import Icon from '../Icon';

export default {
  name: 'AssistantResult',
  props: {
    core: {
      type: Object,
      required: true,
    },
    menu: {
      type: [Object, null],
      required: false,
    },
    chatHistory: {
      type: [Array, null],
      required: false,
    },
    assistantResult: {
      type: String,
      required: true,
    },
    agentInput: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      regenerate: false,
      dropdown: {
        opened: false,
        selected: 'Shorten Text',
      },
    };
  },
  components: {
    Icon,
  },
  computed: {
    generatedLabel() {
      let menu = '';
      if (this.menu !== null) {
        switch (this.menu.id) {
          case 'improve-text':
          case 'shorten-text':
          case 'lengthen-text':
            menu = 'Improved Text Results';
            break;

          case 'ai-generate':
          case 'knowledge-base':
            menu = 'Generate Ideas Result';
            break;

          default:
            break;
        }
      }
      return menu;
    },
    generatedLoaderLabel() {
      let menu = '';
      if (this.menu !== null) {
        switch (this.menu.id) {
          case 'improve-text':
          case 'shorten-text':
          case 'lengthen-text':
            menu = 'is improving your text...';
            break;

          case 'ai-generate':
            menu = 'generating your ideas...';
            break;

          case 'knowledge-base':
            menu = 'is generating your ideas by knowledge base...';
            break;

          default:
            break;
        }
      }
      return menu;
    },
    lastComment() {
      return this.chatHistory !== null ? this.chatHistory[this.chatHistory.length - 1] : null;
    },
    last10Comments() {
      return this.chatHistory !== null ? this.chatHistory.slice(-10) : null;
    },
    last6Comments() {
      return this.chatHistory !== null ? this.chatHistory.slice(-6) : null;
    },
  },
  methods: {
    closeMenu() {
      this.$emit('assistant-changes', {
        history: null,
        input: '',
        menu: null,
      });
      this.$emit('assistant-result', '');
    },
    setDropdown(value) {
      this.dropdown.selected = value;
    },
    regenerateWithOptions() {
      if (this.dropdown.selected === 'Lengthen Text') {
        this.regenerate = true;
        window.aiAssistant.paraphraseLonger(this.assistantResult).then((res) => {
          this.regenerate = false;
          if (res.content) {
            this.$emit('assistant-result', res.content);
          }
        });
      } else {
        this.regenerate = true;
        window.aiAssistant.paraphraseShorter(this.assistantResult).then((res) => {
          this.regenerate = false;
          if (res.content) {
            this.$emit('assistant-result', res.content);
          }
        });
      }
    },
    sendErrorAiAssistant(title, message) {
      const targetWindow = window.parent;
      targetWindow.postMessage({
        name: 'error',
        title,
        message,
      }, window.location.origin);
    },
  },
  watch: {
    menu: {
      deep: true,
      handler(newValue) {
        this.$emit('assistant-result', '');
        const eM = {
          noData: {
            title: 'Failed to Improve',
            message: 'Please enter the sentence that needs to be improved.',
          },
          improve: {
            title: 'Failed to Improve',
            default: 'Encountered an error when improving your text. Please contact your administrator.',
          },
          generate: {
            title: 'Failed to Generate',
            default: 'Encountered an error when generate idea. Please contact your administrator.',
          },
        };
        if (newValue !== null) {
          const history = this.last10Comments.slice(0, -1);
          const question = this.lastComment.content;
          this.setDropdown('Shorten Text');
          switch (newValue.id) {
            case 'improve-text':
              if (this.agentInput !== '') {
                window.aiAssistant.paraphrase(this.agentInput).then((res) => {
                  if (res.content) {
                    this.$emit('assistant-result', res.content);
                  } else if (res.error !== undefined) {
                    this.sendErrorAiAssistant(eM.improve.title, res.error.message);
                    this.closeMenu();
                  } else {
                    this.sendErrorAiAssistant(eM.improve.title, eM.improve.default);
                    this.closeMenu();
                  }
                }).catch(() => {
                  this.sendErrorAiAssistant(eM.improve.title, eM.improve.default);
                  this.closeMenu();
                });
              } else {
                this.sendErrorAiAssistant(eM.noData.title, eM.noData.message);
                this.closeMenu();
              }
              break;
            case 'lengthen-text':
              this.setDropdown('Lengthen Text');
              if (this.agentInput !== '') {
                window.aiAssistant.paraphraseLonger(this.agentInput).then((res) => {
                  if (res.content) {
                    this.$emit('assistant-result', res.content);
                  } else if (res.error !== undefined) {
                    this.sendErrorAiAssistant(eM.improve.title, res.error.message);
                    this.closeMenu();
                  } else {
                    this.sendErrorAiAssistant(eM.improve.title, eM.improve.default);
                    this.closeMenu();
                  }
                }).catch(() => {
                  this.sendErrorAiAssistant(eM.improve.title, eM.improve.default);
                  this.closeMenu();
                });
              } else {
                this.sendErrorAiAssistant(eM.noData.title, eM.noData.message);
                this.closeMenu();
              }
              break;
            case 'shorten-text':
              if (this.agentInput !== '') {
                window.aiAssistant.paraphraseShorter(this.agentInput).then((res) => {
                  if (res.content) {
                    this.$emit('assistant-result', res.content);
                  } else if (res.error !== undefined) {
                    this.sendErrorAiAssistant(eM.improve.title, res.error.message);
                    this.closeMenu();
                  } else {
                    this.sendErrorAiAssistant(eM.improve.title, eM.improve.default);
                    this.closeMenu();
                  }
                }).catch(() => {
                  this.sendErrorAiAssistant(eM.improve.title, eM.improve.default);
                  this.closeMenu();
                });
              } else {
                this.sendErrorAiAssistant(eM.noData.title, eM.noData.message);
                this.closeMenu();
              }
              break;
            case 'ai-generate':
              window.aiAssistant.completions(this.last6Comments).then((res) => {
                if (res.content) {
                  this.$emit('assistant-result', res.content);
                } else if (res.error !== undefined) {
                  this.sendErrorAiAssistant(eM.generate.title, res.error.message);
                  this.closeMenu();
                } else {
                  this.sendErrorAiAssistant(eM.generate.title, eM.generate.default);
                  this.closeMenu();
                }
              }).catch(() => {
                this.sendErrorAiAssistant(eM.generate.title, eM.generate.default);
                this.closeMenu();
              });
              break;

            case 'knowledge-base':
              window.aiAssistant.pekaBgt(question, history).then((res) => {
                if (res.answer) {
                  this.$emit('assistant-result', res.answer);
                } else if (res.error !== undefined) {
                  this.sendErrorAiAssistant(eM.generate.title, res.error.message);
                  this.closeMenu();
                } else {
                  this.sendErrorAiAssistant(eM.generate.title, eM.generate.default);
                  this.closeMenu();
                }
              }).catch(() => {
                this.sendErrorAiAssistant(eM.generate.title, eM.generate.default);
                this.closeMenu();
              });
              break;

            default:
              break;
          }
        }
      },
    },
  },
};
</script>
<style scoped>
/* Style the custom dropdown container */
.custom-dropdown {
  position: relative;
  display: inline-block;
}

/* Style the selected option box */
.custom-dropdown .selected-option {
  color: var(--primary-green-100, #27B199);
  text-align: center;
  /* Subheading 2/Semi Bold */
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 18px */
  letter-spacing: 0.06px;
}

/* Style the options list */
.custom-dropdown .options {
  position: absolute;
  top: 100%;
  left: 0;
  display: none;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 8px;
  z-index: 1;
  width: 200%;
}

/* Show the options list when the selected option is clicked */
.custom-dropdown.active .options {
  display: block;
}

/* Style each option in the list */
.custom-dropdown .option {
  padding: 6px 12px;
}

/* Highlight the selected option */
.custom-dropdown .option:hover {
  background-color: #f0f0f0;
}
.assistant-result-actions-right .apply-text{
  display: flex;
  height: 32px;
  padding: 8px 18px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  border: 1px solid var(--primary-green-1, #27B199);
  background: var(--primary-green-1, #27B199);
  color: var(--typograph-and-font-white, #FFF);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 18px */
  letter-spacing: 0.06px;
  cursor: pointer;
}
.assistant-result-actions-right .regenerate{
  cursor: pointer;
  display: flex;
  height: 32px;
  padding: 8px 18px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  border: 1px solid var(--primary-green-1, #27B199);
}
.assistant-result-actions-right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}
.assistant-result-actions-left{
  display: flex;
  height: 32px;
  padding: 8px 18px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  border: 1px solid var(--primary-green-1, #27B199);
  cursor: pointer;
}
.assistant-result-actions{
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.assistant-result-loader{
  display: flex;
  align-items: center;
  gap: 8px;
}
.assistant-result-loader span{
  color: var(--typograph-and-font-text-field-empty, #A0A0A0);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  letter-spacing: 0.07px;
}
.assistant-result-loader img{
  width: 24px;
  height: 24px;
}
.assistant-result-wrapper{
  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}
.assistant-result-header-right{
  cursor:pointer;
}
.assistant-result-header-left{
  display: flex;
  align-items: center;
  gap: 8px;
}
.assistant-result-header-left *, .assistant-result-header-right *{
  margin: 0px;
}
.assistant-result-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.assistant-result-header-left .qc-icon{
  color:#27B199;
}
</style>



// WEBPACK FOOTER //
// src/components/ai-assistant/result.vue